import { FC } from 'react'
import { LoaderCircleIcon } from 'lucide-react'

export const LoadingScreen: FC = () => {
    return (
        <div className={'w-full h-full flex items-center justify-center'}>
            <LoaderCircleIcon className="size-12 animate-spin" />
        </div>
    )
}
